const Device = {
    Mobile: 'mobile',
    Desktop: 'desktop',
    Large: 'large',
};

const get = (w) => {
    if (w > 1414) return Device.Large;
    else if (w > 767) return Device.Desktop;
    else return Device.Mobile;
};

export { get as getDevice, Device as DeviceType };
